export enum SlideLayout {
  TEXT_RIGHT_MEDIA_LEFT = 'text_right_image_left',
  TEXT_LEFT_MEDIA_RIGHT = 'image_right_text_left',
  TEXT_TOP_MEDIA_BOTTOM = 'main_text_top',
  TEXT_BOTTOM_MEDIA_TOP = 'main_text_bottom'
}
